import dayjs from "dayjs";
import { isAgreement, isExpired, isTender } from "@/lib/agreementUtilities";

export enum AgreementVariant {
  AFTALE = "aftale",
  UDBUD = "udbud", 
  DANGER = "danger"
}

export enum AgreementType {
  AFTALE = "Aftale",
  UDBUD = "Udbud",
  TIDLIGERE_AFTALE = "Tidligere aftale"
}

export class AgreementTypeInfo {
  constructor(
    public readonly type: AgreementType,
    public readonly variant: AgreementVariant
  ) {}

  toString(): string {
    return this.type;
  }
}

export function getAgreementTypes(): { name: string }[] {
  return [
    { name: AgreementType.UDBUD },
    { name: AgreementType.AFTALE },
    { name: AgreementType.TIDLIGERE_AFTALE },
  ];
}

export function getAgreementTypeInfo(
  statusName: string, 
  expirationDate?: Date | string | dayjs.Dayjs
): AgreementTypeInfo {
  if (
    isAgreement(statusName) ||
    isExpired(statusName)
  ) {
    const expDate = dayjs(expirationDate);
    const yesterday = dayjs().add(-1, "day").utc();
    const isExpiredByDate = expirationDate && expDate.isBefore(yesterday);
    debugger;
    if (isExpiredByDate) {
      return new AgreementTypeInfo(AgreementType.TIDLIGERE_AFTALE, AgreementVariant.DANGER);
    } else {
      return new AgreementTypeInfo(AgreementType.AFTALE, AgreementVariant.AFTALE);
    }
  } else if (isTender(statusName)) {
    return new AgreementTypeInfo(AgreementType.UDBUD, AgreementVariant.UDBUD);
  }
  
  // Default fallback
  return new AgreementTypeInfo(AgreementType.AFTALE, AgreementVariant.AFTALE);
} 